import cn from 'classnames';

import { DayPicker } from 'react-day-picker';
import DropDown from '../../DropDown';
import styles_calendar from './style.module.css';
import styles from './styles.module.scss';

/**
 * Компонент календаря. Св-ва:
 * - period - преобразуется во внутренний periodObj (только при первичном рендере).
 * - changeCb - колбэк с обратными преобразованием. Вызывается если было нажато "Применить"
 * - closeCb - колбэк, если календарь инициировал своё закрытие (клик по маске или было нажато "Применить")
 *
 * Св-во period - массив с двумя датами, каждая либо ISO 8601 либо null.
 * Состояние periodObj, совместимое с <Calendar>, имеет вид { from: Date, to: Date }.
 * Для преобразования используются методы periodToObj и periodFromObj.
 */
import ru from 'date-fns/locale/ru';
import { TYPE_BUTTONS } from '../../../../../constans';
import Button from '../../../Buttons/Button';
import Row from '../../../Blocks/Row';

const WEEKDAYS_SHORT_RU = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
const MONTHS_RU = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

const CalendarBase = ({
  closeCb = () => { },
  handleClose = () => { },
  className,
  disabled = false,
  stylesCalendar,
  stylesDaySelected,
  ...props
}) => {
  return (
    <DropDown close={closeCb} styles={cn(styles.drop_down_calendar, className)}>
      <div className={styles.calendar_content}>
        <DayPicker
          className="Selectable"
          classNames={styles_calendar}
          locale={ru}
          disabled={disabled}
          weekdaysShort={WEEKDAYS_SHORT_RU}
          months={MONTHS_RU}
          numberOfMonths={1}
          firstDayOfWeek={1}
          {...props}
        />

        <Row style={{ marginTop: '10px' }}>
          <Button type={TYPE_BUTTONS.GREY} style={{ marginRight: '15px' }} onClick={closeCb}>
            Закрыть
          </Button>
          <Button type={TYPE_BUTTONS.WHITE} onClick={handleClose}>
            Применить
          </Button>
        </Row>
      </div>
    </DropDown>
  );
};

export default CalendarBase;
